module.exports = __webpack_public_path__ + "static/media/02-Adding-broadcast-times-campaign.cc211873.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/statsradio/modules/tutorials/assets/pdfs/follo/en/02-Adding-broadcast-times-campaign.pdf
// module id = ./src/statsradio/modules/tutorials/assets/pdfs/follo/en/02-Adding-broadcast-times-campaign.pdf
// module chunks = 18